export const styles = {
  root: {
    position: 'relative',
  },
  hide: {
    position: 'absolute',
    bottom: 0,
    background: '#FFFFFF',
    width: '100%',
    height: 70,
  },
}
